import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './TemplatesTypes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { motion } from "motion/react";
import { Link } from 'react-router-dom';

const newsletterTemplates = [
    {
        id: 'interior-design-newsletter',
        title: 'Interior Design',
        description: 'A modern, stylish newsletter template for interior design updates.',
        img: require('../../assets/imgs/previews/newsletters/interiordesign.jpg'),
        mobileImg: require('../../assets/imgs/previews/mobile/newsletters/interiordesign.jpg'),
        canvaEmbed: 'https://www.canva.com/design/DAGjmjVnhlM/1TemYYDM7QBLNy5q1mgUVQ/view?embed',
        canvaLink: 'https://www.canva.com/design/DAGjmjVnhlM/1TemYYDM7QBLNy5q1mgUVQ/view?utm_content=DAGjmjVnhlM&utm_campaign=designshare&utm_medium=embeds&utm_source=link',
        author: 'APTO Websites'
    },
    {
        id: 'spring-real-estate-update',
        title: 'Spring Update',
        description: 'A fresh, seasonal newsletter template for spring real estate news and updates.',
        img: require('../../assets/imgs/previews/newsletters/springupdate.jpg'),
        mobileImg: require('../../assets/imgs/previews/mobile/newsletters/springupdate.jpg'),
        canvaEmbed: 'https://www.canva.com/design/DAGjsrd2OZc/a64PBzo4_m69HE2DIkcwBg/view?embed',
        canvaLink: 'https://www.canva.com/design/DAGjsrd2OZc/a64PBzo4_m69HE2DIkcwBg/view?utm_content=DAGjsrd2OZc&utm_campaign=designshare&utm_medium=embeds&utm_source=link',
        author: 'APTO Websites'
    },
    {
        id: 'monthly-featured-listings',
        title: 'Featured Listings',
        description: 'Showcase your top listings each month with this clean, modern newsletter template.',
        img: require('../../assets/imgs/previews/newsletters/monthlyfeatured.jpg'),
        mobileImg: require('../../assets/imgs/previews/mobile/newsletters/monthlyfeatured.jpg'),
        canvaEmbed: 'https://www.canva.com/design/DAGj-kyJ4Nk/B75LWNarCGiLFdFHUBVCKQ/view?embed',
        canvaLink: 'https://www.canva.com/design/DAGj-kyJ4Nk/B75LWNarCGiLFdFHUBVCKQ/view?utm_content=DAGj-kyJ4Nk&utm_campaign=designshare&utm_medium=embeds&utm_source=link',
        author: 'APTO Websites'
    },
    {
        id: 'buyers-guide',
        title: 'Buyer’s Guide',
        description: 'A helpful newsletter template for educating buyers and sharing tips.',
        img: require('../../assets/imgs/previews/newsletters/buyersguide.jpg'),
        mobileImg: require('../../assets/imgs/previews/mobile/newsletters/buyersguide.jpg'),
        canvaEmbed: 'https://www.canva.com/design/DAGkoIK1ll4/j9V464nzsYhg-hI7a6PVZw/view?embed',
        canvaLink: 'https://www.canva.com/design/DAGkoIK1ll4/j9V464nzsYhg-hI7a6PVZw/view?utm_content=DAGkoIK1ll4&utm_campaign=designshare&utm_medium=embeds&utm_source=link',
        author: 'APTO Websites'
    },
    // Add more newsletter templates here
];

const Newsletters = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const filteredTemplates = newsletterTemplates.filter(template =>
        template.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        template.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <Helmet>
                <title>Newsletter Templates | AptoWebsites</title>
                <meta name="description" content="Beautiful, responsive newsletter templates to keep your clients engaged and informed. Perfect for real estate professionals." />
                <meta name="keywords" content="newsletter templates, real estate newsletters, email marketing, AptoWebsites" />
                <meta property="og:title" content="Newsletter Templates | AptoWebsites" />
                <meta property="og:description" content="Beautiful, responsive newsletter templates to keep your clients engaged and informed." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/newsletters" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/newsletters" />
            </Helmet>
            <div className="templatebackground">
                <div className="template-header-bar professional">
                    <div className="template-header-titles">
                        <h1 className="template-header-title">Newsletter Templates</h1>
                    </div>
                    <div className="template-header-controls">
                        <div className="template-search-group">
                            {/* <svg className="search-icon" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                <circle cx="9" cy="9" r="7" stroke="#0d47a1" strokeWidth="2"/>
                                <line x1="14.4142" y1="14" x2="18" y2="17.5858" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round"/>
                            </svg> */}
                            <div className='icon-wrapper'>
                                <FontAwesomeIcon icon={faSearch} className='search-icon' />
                            </div>
                            <input
                                type="text"
                                placeholder="Search newsletters..."
                                value={searchQuery}
                                onChange={e => setSearchQuery(e.target.value)}
                                className="filter-input template-search-input"
                            />
                        </div>
                    </div>
                </div>
                <div className="template-section">
                    <div className="template-list">
                        {filteredTemplates.map(template => (
                            <motion.div
                                key={template.id}
                                className="template-box"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setSelectedTemplate(template)}
                                initial="rest"
                                whileHover="hover"
                                animate="rest"
                            >
                                <motion.div className="template-img-wrapper overlap">
                                    <img
                                        src={require('../../assets/imgs/mockups/laptop-mockup1.png')}
                                        alt="Laptop Mockup"
                                        className="mockup-frame"
                                    />

                                    <div className="screen-img">
                                        <img
                                            src={template.img}
                                            alt={template.title}
                                            className="template-img main-img"
                                        />
                                    </div>
                                    <div className="phone-mockup-container overlap">
                                        <img
                                            src={require('../../assets/imgs/mockups/phone-mockup-transparent.png')}
                                            alt="Phone Mockup"
                                            className="phone-mockup-img"
                                        />
                                        <img
                                            src={template.mobileImg}
                                            alt={`${template.title} mobile`}
                                            className="template-img phone-inside-img"
                                        />
                                    </div>
                                </motion.div>
                                <span className="template-card-label">{template.title}</span>
                                {/* <div className="template-info">
                                    <h3>{template.title}</h3>
                                    <p>{template.description}</p>
                                </div> */}
                                <motion.div
                                    className="template-info overlay"
                                    variants={{
                                        rest: {
                                            clipPath: "inset(65% 50% 40px 15px round 10px)",
                                            justifyContent: "flex-end",
                                            alignItems: "start",
                                            background: "#3a3c3f",
                                        },
                                        hover: {
                                            clipPath: "inset(0% 0% 0% 0% round 10px)",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            background: "rgba(59, 60, 63, 0.92)"
                                        }
                                    }}

                                    transition={{ duration: 0.4, ease: "easeInOut" }}
                                >
                                    <h3 className="template-title">{template.title}</h3>

                                    <div className="template-extra">
                                        <p>{template.description}</p>
                                    </div>
                                </motion.div>
                            </motion.div>
                        ))}
                    </div>
                </div>
                {selectedTemplate && (
                    <div
                        className="newsletter-modal-overlay"
                        onClick={() => setSelectedTemplate(null)}
                    >
                        <div
                            className="newsletter-modal"
                            onClick={e => e.stopPropagation()}
                        >
                            <button
                                className="newsletter-modal-close"
                                onClick={() => setSelectedTemplate(null)}
                                aria-label="Close"
                            >&times;</button>
                            <div className="newsletter-modal-iframe-container">
                                <iframe
                                    loading="lazy"
                                    className="newsletter-modal-iframe"
                                    src={selectedTemplate.canvaEmbed}
                                    allowFullScreen
                                    title={selectedTemplate.title}
                                />
                            </div>
                            <Link
                                to={selectedTemplate.canvaLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="newsletter-modal-link"
                            >
                                {selectedTemplate.title}
                            </Link>
                            <span className="newsletter-modal-author">
                                by {selectedTemplate.author}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Newsletters;
